/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmplifyPostRequest } from '../../models/amplify-post-request';
import { AmplifyPostResponse } from '../../models/amplify-post-response';

export interface AmplifyPost$Params {
  id: number;
      body?: {
'request': AmplifyPostRequest;
}
}

export function amplifyPost(http: HttpClient, rootUrl: string, params: AmplifyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AmplifyPostResponse>> {
  const rb = new RequestBuilder(rootUrl, amplifyPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmplifyPostResponse>;
    })
  );
}

amplifyPost.PATH = '/api/post/{id}/amplify';
